import { KeenSliderInstance } from 'keen-slider'

import { byDevice } from './carousel-layout'

import { IRANIAN_WOMEN_CAROUSEL } from '../constants'

interface ApplySliderSlideStylesParams {
    visibleSideCount: number
    isMobile: boolean
}

export const applySliderSlideStyles = (
    slider: KeenSliderInstance,
    { visibleSideCount, isMobile }: ApplySliderSlideStylesParams
): void => {
    const elements = slider.slides

    if (!elements.length) return

    const containerRect = slider.container.getBoundingClientRect()
    const containerCenter = containerRect.left + containerRect.width / 2

    const centers = elements.map((element) => {
        const rect = element.getBoundingClientRect()

        return rect.left + rect.width / 2
    })

    const sortedCenters = [...centers].sort((a, b) => a - b)
    let step = containerRect.width

    for (let i = 1; i < sortedCenters.length; i++) {
        const gap = sortedCenters[i] - sortedCenters[i - 1]

        if (gap > 1 && gap < step) step = gap
    }

    const sizes = byDevice(IRANIAN_WOMEN_CAROUSEL.scaledSizes, isMobile)
    const baseSize = sizes[0]
    const sizeRatios = sizes.map((size) => size / baseSize)
    const lastRatioIdx = sizeRatios.length - 1

    elements.forEach((slideElement, index) => {
        const imageWrapper = slideElement.firstElementChild
        const slotDistance = step ? Math.abs(centers[index] - containerCenter) / step : 0

        let scale = sizeRatios[lastRatioIdx]

        if (slotDistance < lastRatioIdx) {
            const i = Math.floor(slotDistance)
            const fraction = slotDistance - i

            scale = sizeRatios[i] + (sizeRatios[i + 1] - sizeRatios[i]) * fraction
        }

        const opacity = slotDistance > visibleSideCount ? Math.max(0, 1 - (slotDistance - visibleSideCount)) : 1
        const zIndex = Math.round(Math.max(0, visibleSideCount + 1 - slotDistance) * 10)

        slideElement.style.opacity = `${opacity}`
        slideElement.style.zIndex = `${zIndex}`

        if (imageWrapper instanceof HTMLElement) {
            imageWrapper.style.transform = `scale(${scale})`
        }
    })
}
